import { ClassCard } from '../../../../components/class-card';
import type { ClassCardOptions } from '../../../../components/class-card/class-card.options';
import { useClassroomCapabilities } from '../../../../hooks/use-classroom-capabilities';
import { Classroom } from '../../../../modules/classroom';

type Props = {
  journey: Classroom;
  isDisabled?: boolean;
  options: ClassCardOptions;
  onClick: () => void;
};

function JourneyCard({
  journey,
  isDisabled = false,
  options,
  onClick,
}: Props): JSX.Element {
  const {
    classroom: { shouldShowAlias },
  } = useClassroomCapabilities({ classroom: journey });

  const getSubtitle = () => {
    return shouldShowAlias ? journey.name : '';
  };

  const getTitle = () => {
    return shouldShowAlias ? journey.alias : journey.name;
  };

  return (
    <ClassCard
      isDisabled={isDisabled}
      title={getTitle()}
      subtitle={getSubtitle()}
      classroom={journey}
      options={options}
      onClick={onClick}
    />
  );
}

export { JourneyCard };
